(function () {
  function fastPayWrap() {
    return document.querySelector('.shopify-payment-button');
  }

  function addonSelected() {
    return !!document.querySelector(
      '.essential-upsell-product-addon-block input:checked,' +
      'essential-upsell-product-addon-app-block input:checked,' +
      '.essential-upsell-product-addon-app-block input:checked'
    );
  }

  function syncFastPayVisibility() {
    const pay = fastPayWrap();
    if (!pay) return;
    pay.style.display = addonSelected() ? 'none' : '';
  }

  document.addEventListener('DOMContentLoaded', syncFastPayVisibility);
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[type="checkbox"], input[type="radio"]')) {
      syncFastPayVisibility();
    }
  });

  // Tema AJAX ile tekrar render ediyorsa diye
  const mo = new MutationObserver(syncFastPayVisibility);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
